
import { Scan } from "lucide-react";

interface ScannerOverlayProps {
  videoRef: React.RefObject<HTMLDivElement>;
}

export const ScannerOverlay = ({ videoRef }: ScannerOverlayProps) => {
  return (
    <div className="relative bg-black rounded-lg overflow-hidden" style={{ aspectRatio: '4/3', width: '100%' }}>
      <div 
        ref={videoRef} 
        className="w-full h-full"
        style={{ position: 'relative' }}
      />
      <div className="absolute inset-4 border-2 border-green-500 border-dashed rounded-lg flex items-center justify-center pointer-events-none">
        <div className="text-white text-center bg-black bg-opacity-60 p-2 rounded">
          <Scan className="w-6 h-6 mx-auto mb-1" />
          <p className="text-xs">Align barcode here</p>
        </div>
      </div>
    </div>
  );
};
